export const PROVIDERS_API = `/gateway/api/object-resolver/providers`;
export const LS_PROVIDER_KEY = 'aiMateSmartLinkProviders';
